import { Button, Col, Container, Row } from "react-bootstrap"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import QuickForm from "../../Components/Forms/QuickForm/QuickForm"
import { convertActiveQueryToUrl } from "../../Helpers/Query/queryHelpers"
import useActiveQueryHook from "../../Hooks/UseActiveQuery/useActiveQueryHook"
import { useGetBuildingAmenitiesQuery } from "../../services/bClientApi"
import MongoPagination from "../../Components/Pagination/MongoPagination"
import { BuildingAmenityType } from "../../Types/buildingAmenityTypes"
import BuildingAmenityEntry from "../../Components/BuildingAmenity/BuildingAmenityEntry/BuildingAmenityEntry"
import useBuildingSelectValues from "../../Hooks/UseBuildings/useBuildingSelectValuesHook"
import useAmenitySelectValues from "../../Hooks/UseAmenities/useAmenitySelectValuesHook"

export default function BuildingAmenitiesPage() {

    const dispatch = useAppDispatch()

    const buildingOptions = useBuildingSelectValues()
    const amenityOptions = useAmenitySelectValues()

    const { activeQuery } = useActiveQueryHook({
        query: {},
        limit: 10,
    })

    const {
        data,
        error,
        isLoading,
    } = useGetBuildingAmenitiesQuery({
        buildingAmenitiesQuery: activeQuery.query,
        pagination: {
            page: activeQuery.page,
            limit: activeQuery.limit,
        }
    })
    const buildingAmenitiesList = data?.docs || []

    const loadPage = (pageParams: { query: any, page: number, limit: number }) => {
        const destination = `/building-amenities?${convertActiveQueryToUrl(pageParams)}`
        dispatch(navigateTo(destination))
    }

    return (
        <Container>
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>Building Amenities</h1>
                        <Button
                            variant="primary"
                            onClick={() => dispatch(navigateTo('/add-building-amenity'))}
                        >
                            Add Building Amenity
                        </Button>
                    </div>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <QuickForm
                        layout={{ xs: 2 }}
                        initialData={{
                            buildingId: activeQuery.query.buildingId,
                            amenityId: activeQuery.query.amenityId,
                        }}
                        fields={[
                            {
                                fieldName: 'buildingId',
                                fieldLabel: 'Building',
                                fieldType: 'select',
                                placeholder: '- All Buildings -',
                                options: buildingOptions,
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'amenityId',
                                fieldLabel: 'Amenity',
                                fieldType: 'select',
                                placeholder: '- All Amenities -',
                                options: amenityOptions,
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                        ]}
                        disabled={isLoading}
                        onSubmit={(values: any) => {
                            const query: any = { ...values }
                            loadPage({
                                query,
                                page: 1,
                                limit: activeQuery.limit
                            })
                        }}
                    />

                    <div className="building-amenities-list-container">
                        {buildingAmenitiesList && buildingAmenitiesList.length > 0 ? (
                            <div>
                                {buildingAmenitiesList.map((buildingAmenity: BuildingAmenityType, idx: number) => {
                                    return (
                                        <BuildingAmenityEntry
                                            key={`${buildingAmenity._id}-${idx}`}
                                            buildingAmenityData={buildingAmenity}
                                        />
                                    )
                                })}
                            </div>
                        ) : (
                            <div className="text-center p-4">
                                <h5>No building amenities found</h5>
                                <p>Try adjusting your search filters or add a new building amenity.</p>
                            </div>
                        )}
                    </div>

                    <MongoPagination
                        data={data}
                        loadPage={(pageLoadInfo: { page: number, limit?: number }) => {
                            loadPage({
                                query: activeQuery.query,
                                limit: activeQuery.limit,
                                ...pageLoadInfo
                            })
                        }}
                    />
                </Col>
            </Row>
        </Container>
    )
}
